import { render, staticRenderFns } from "./CalendarWork.vue?vue&type=template&id=4a896966&scoped=true&"
import script from "./CalendarWork.vue?vue&type=script&lang=js&"
export * from "./CalendarWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a896966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a896966')) {
      api.createRecord('4a896966', component.options)
    } else {
      api.reload('4a896966', component.options)
    }
    module.hot.accept("./CalendarWork.vue?vue&type=template&id=4a896966&scoped=true&", function () {
      api.rerender('4a896966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Work/CalendarWork.vue"
export default component.exports